import { render, staticRenderFns } from "./ui-copy-input.vue?vue&type=template&id=353d0c33&scoped=true&"
import script from "./ui-copy-input.vue?vue&type=script&lang=ts&"
export * from "./ui-copy-input.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353d0c33",
  null
  
)

export default component.exports